// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.call-to-action {
  padding: 4rem 2rem;
  background: var(--color-secondary);
  width: 100%;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.call-to-action::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.call-to-action-content {
  max-width: 1500px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4rem;
  position: relative;
  z-index: 1;
  padding: 6rem 2rem;
  background-image: var(--cta-background-image);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.call-to-action-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background: var(--color-secondary); */
  opacity: 0.8;
  pointer-events: none;
  z-index: -1;
}

.cta-text {
  flex: 1 1;
  text-align: right;
  max-width: 500px;
}

.cta-title,
.cta-subtitle {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.1;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--color-text-primary);
}

.cta-subtitle {
  margin-top: 0.2rem;
}

.cta-button {
  background-color: var(--color-white);
  color: var(--color-primary);
  border: none;
  padding: 1.2rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cta-button:hover {
  background-color: var(--color-white);
  opacity: 0.9;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.cta-button:active {
  transform: translateY(-1px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .call-to-action {
    padding: 3rem 1rem;
  }

  .call-to-action-content {
    flex-direction: column;
    text-align: center;
    gap: 2rem;
  }

  .cta-title,
  .cta-subtitle {
    font-size: 1.8rem;
  }

  .cta-button {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .call-to-action {
    padding: 2rem 1rem;
  }

  .cta-title,
  .cta-subtitle {
    font-size: 1.3rem;
  }

  .cta-button {
    padding: 1rem 2rem;
    font-size: 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/CallToAction/CallToAction.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,6CAA6C;EAC7C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".call-to-action {\n  padding: 4rem 2rem;\n  background: var(--color-secondary);\n  width: 100%;\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n}\n\n.call-to-action::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n}\n\n.call-to-action-content {\n  max-width: 1500px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4rem;\n  position: relative;\n  z-index: 1;\n  padding: 6rem 2rem;\n  background-image: var(--cta-background-image);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden;\n}\n\n.call-to-action-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* background: var(--color-secondary); */\n  opacity: 0.8;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.cta-text {\n  flex: 1;\n  text-align: right;\n  max-width: 500px;\n}\n\n.cta-title,\n.cta-subtitle {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.1;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--color-text-primary);\n}\n\n.cta-subtitle {\n  margin-top: 0.2rem;\n}\n\n.cta-button {\n  background-color: var(--color-white);\n  color: var(--color-primary);\n  border: none;\n  padding: 1.2rem 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border-radius: 15px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  flex-shrink: 0;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cta-button:hover {\n  background-color: var(--color-white);\n  opacity: 0.9;\n  transform: translateY(-3px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\n}\n\n.cta-button:active {\n  transform: translateY(-1px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .call-to-action {\n    padding: 3rem 1rem;\n  }\n\n  .call-to-action-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 2rem;\n  }\n\n  .cta-title,\n  .cta-subtitle {\n    font-size: 1.8rem;\n  }\n\n  .cta-button {\n    width: 100%;\n    max-width: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n  .call-to-action {\n    padding: 2rem 1rem;\n  }\n\n  .cta-title,\n  .cta-subtitle {\n    font-size: 1.3rem;\n  }\n\n  .cta-button {\n    padding: 1rem 2rem;\n    font-size: 1rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
